import { ActionDTO } from '@behavior/activity/dto/ActionDTO';
import { UserDTO } from '@behavior/init/dto/UserDTO';
import { ActionState } from '@components/Activity/types/ActionState';
import { useState } from 'react';

export const useActionState = () => {
  const [actionCard, setActionCard] = useState<number[]>([]);
  const [count, setCount] = useState(0);
  const [description, setDescription] = useState('');
  const [assignedUser, setAssignedUser] = useState<UserDTO>();
  const [completionDte, setCompletionDte] = useState('');
  const [actionCardContent, setActionCardContent] = useState<ActionDTO>();
  const [actionCardContentList, setActionCardContentList] = useState<ActionDTO[]>([]);

  return {
    actionCard,
    setActionCard,
    count,
    setCount,
    description,
    setDescription,
    assignedUser,
    setAssignedUser,
    completionDte,
    setCompletionDte,
    actionCardContent,
    setActionCardContent,
    actionCardContentList,
    setActionCardContentList,
  } as ActionState;
};
